"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_3 = require("vue");
const common_1 = require("../../common/common");
const timeZones_1 = __importDefault(require("../../common/timeZones"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'TimeIndicator',
    props: {
        cellHeight: {
            type: Number,
            required: true,
        },
        timeView: {
            type: Array,
            required: true,
        },
    },
    setup(__props) {
        const timeIndicatorTop = (0, vue_3.ref)(0);
        const isWithinWorkingHours = (0, vue_3.ref)(true);
        const timeIndicatorInterval = (0, vue_3.ref)(null);
        const props = __props;
        function updateIndicatorPosition() {
            const time = (0, common_1.dateToKitchenTime)(new Date(), timeZones_1.default.ASIA_TOKYO);
            const { hour = 0, min = 0 } = (0, common_1.extractTimeAndMin)(time, false);
            const currentTime = hour + min / 60;
            const roundedTime = Math.floor(currentTime);
            // Check if current hour is part of the visible range
            const index = props.timeView.findIndex(h => h === roundedTime);
            if (index === -1) {
                isWithinWorkingHours.value = false;
                return;
            }
            isWithinWorkingHours.value = true;
            const minutesOffset = currentTime - roundedTime;
            timeIndicatorTop.value = (index + minutesOffset + 1) * props.cellHeight + 30;
        }
        const timeIndicatorStyle = (0, vue_3.computed)(() => ({
            top: `${timeIndicatorTop.value}px`,
        }));
        (0, vue_3.onMounted)(() => {
            updateIndicatorPosition();
            timeIndicatorInterval.value = setInterval(updateIndicatorPosition, 60000); // update every minute
        });
        (0, vue_3.onUnmounted)(() => {
            if (timeIndicatorInterval.value) {
                clearInterval(timeIndicatorInterval.value);
            }
        });
        return (_ctx, _cache) => {
            return (isWithinWorkingHours.value)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                    (0, vue_2.createElementVNode)("div", {
                        class: "time-indicator-line",
                        style: (0, vue_2.normalizeStyle)(timeIndicatorStyle.value)
                    }, null, 4 /* STYLE */),
                    (0, vue_2.createElementVNode)("div", {
                        class: "time-indicator-circle-wrapper",
                        style: (0, vue_2.normalizeStyle)(timeIndicatorStyle.value)
                    }, [...(_cache[0] || (_cache[0] = [
                            (0, vue_2.createElementVNode)("div", { class: "time-indicator-circle" }, null, -1 /* CACHED */)
                        ]))], 4 /* STYLE */)
                ], 64 /* STABLE_FRAGMENT */))
                : (0, vue_2.createCommentVNode)("v-if", true);
        };
    }
});
